// import React, {
//   useState,
//   useEffect,
//   useMemo,
//   useCallback,
// } from "react";

// import {
//   Card,
//   TextField,
//   InputAdornment,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableSortLabel,
//   Paper,
//   TablePagination,
//   Typography,
//   Box,
//   CircularProgress,
//   useTheme,
//   useMediaQuery,
//   Button,
//   Grid,
//   IconButton,
//   Tooltip,
//   Stack,
// } from "@mui/material";

// import SearchIcon from "@mui/icons-material/Search";
// import RestartAltIcon from "@mui/icons-material/RestartAlt";
// import DeleteIcon from "@mui/icons-material/Delete";

// import toast from "react-hot-toast";
// import configServ from "../services/config";
// import { useSelector } from "react-redux";

// // ------------------------------------------------------------------
// // Constants
// // ------------------------------------------------------------------

// const DAY_NUMBER_TO_KEY = {
//   0: "sun",
//   1: "mon",
//   2: "tue",
//   3: "wed",
//   4: "thu",
//   5: "fri",
//   6: "sat",
// };

// // Sun(0) ... Sat(6) — matches Date.getDay()
// const DOW_SHORT = [
//   "Sun",
//   "Mon",
//   "Tue",
//   "Wed",
//   "Thu",
//   "Fri",
//   "Sat",
// ];

// // How long to wait after the user stops typing in the
// // Name/Code or Department field before we hit the backend again.
// const SEARCH_DEBOUNCE_MS = 400;

// // ------------------------------------------------------------------
// // Date Helpers
// // ------------------------------------------------------------------

// function pad(n) {
//   return String(n).padStart(2, "0");
// }

// function parseApiDate(value) {
//   if (!value) return null;

//   const str = String(value);

//   if (str.includes("T")) {
//     return new Date(str);
//   }

//   return new Date(
//     `${str.substring(0, 10)}T00:00:00`
//   );
// }

// function toInputDate(value) {
//   if (!value) return "";

//   if (value instanceof Date) {
//     return `${value.getFullYear()}-${pad(
//       value.getMonth() + 1
//     )}-${pad(value.getDate())}`;
//   }

//   return String(value).substring(0, 10);
// }

// function getDateKey(value) {
//   const date =
//     value instanceof Date
//       ? value
//       : parseApiDate(value);

//   if (!date || Number.isNaN(date.getTime())) {
//     return "";
//   }

//   return `${date.getFullYear()}-${pad(
//     date.getMonth() + 1
//   )}-${pad(date.getDate())}`;
// }

// function addDays(date, delta) {
//   const d = new Date(date);
//   d.setDate(d.getDate() + delta);
//   return d;
// }

// function getCurrentMonthRange() {
//   const today = new Date();

//   const start = new Date(
//     today.getFullYear(),
//     today.getMonth(),
//     1
//   );

//   const end = new Date(
//     today.getFullYear(),
//     today.getMonth() + 1,
//     0
//   );

//   return {
//     start: toInputDate(start),
//     end: toInputDate(end),
//   };
// }

// // Builds the "live calendar" columns for the table:
// // one column per actual date between start and end (inclusive),
// // each flagged as weekend (Sat/Sun) or not.
// //
// // If either date is missing (no date filter applied yet), no
// // date columns are shown at all — this is what keeps the
// // calendar "unselected" by default.
// function buildDateColumns(startStr, endStr) {
//   if (!startStr || !endStr) {
//     return [];
//   }

//   const start = parseApiDate(startStr);
//   const end = parseApiDate(endStr);

//   if (
//     !start ||
//     !end ||
//     Number.isNaN(start.getTime()) ||
//     Number.isNaN(end.getTime()) ||
//     start > end
//   ) {
//     return [];
//   }

//   const columns = [];
//   let cursor = new Date(start);
//   let guard = 0; // safety cap so a bad range can't freeze the UI

//   while (cursor <= end && guard < 370) {
//     const dow = cursor.getDay();

//     columns.push({
//       dateKey: getDateKey(cursor),
//       dateNum: cursor.getDate(),
//       dayShort: DOW_SHORT[dow],
//       isWeekend: dow === 0 || dow === 6,
//     });

//     cursor = addDays(cursor, 1);
//     guard += 1;
//   }

//   return columns;
// }

// // ------------------------------------------------------------------
// // API Row -> Display Row
// // ------------------------------------------------------------------

// function normalizeRosterResponse(response) {
//   if (Array.isArray(response)) {
//     return response;
//   }

//   if (Array.isArray(response?.data)) {
//     return response.data;
//   }

//   if (Array.isArray(response?.data?.data)) {
//     return response.data.data;
//   }

//   return [];
// }

// // ------------------------------------------------------------------
// // Group API Entries
// //
// // Backend returns one entry per:
// // roster + customer + date.
// //
// // We first collapse that down to one entry per:
// // roster + employee + date (dedup customers into customerIds).
// //
// // The calendar table itself is built separately from this
// // (see useMemo `employeeRows` below), grouping these flat rows
// // by employee so each employee gets ONE row with all their dates
// // as columns.
// // ------------------------------------------------------------------

// function transformRosterEntries(apiRows) {
//   const grouped = new Map();

//   apiRows.forEach((item) => {
//     const rosterId = Number(
//       item.roster_id ||
//       item.id ||
//       item.rosterId
//     );

//     const employeeId = Number(
//       item.employee_id
//     );

//     const date =
//       item.roster_date ||
//       item.date;

//     if (!rosterId || !employeeId || !date) {
//       return;
//     }

//     const dateKey = getDateKey(date);

//     const key = `${rosterId}_${employeeId}_${dateKey}`;

//     if (!grouped.has(key)) {
//       grouped.set(key, {
//         roster_id: rosterId,

//         employee_id: employeeId,

//         employee_name:
//           item.employee_name ||
//           item.name ||
//           `Employee #${employeeId}`,

//         employee_code:
//           item.employee_code ||
//           item.emp_code ||
//           "",

//         department_id: Number(
//           item.department_id ||
//           item.dept_id ||
//           0
//         ),

//         department_name:
//           item.department_name ||
//           item.dept_name ||
//           item.department ||
//           "",

//         date: dateKey,

//         shift_id: Number(
//           item.shift_id || 0
//         ),

//         shift_name:
//           item.shift_name || "",

//         shift_code:
//           item.shift_code || "",

//         shift_time:
//           item.shift_time ||
//           item.formatted_shift_time ||
//           "",

//         // That day's actual attendance punch (from the backend's
//         // attendances left-join) — null when not punched yet.
//         // If the backend doesn't return these, they'll be null.
//         punch_in:
//           item.punch_in || null,

//         punch_out:
//           item.punch_out || null,

//         status:
//           item.status ?? 1,

//         customerIds: [],
//       });
//     }

//     const row = grouped.get(key);

//     const customerId = Number(
//       item.customer_id
//     );

//     if (
//       customerId &&
//       !row.customerIds.includes(
//         customerId
//       )
//     ) {
//       row.customerIds.push(
//         customerId
//       );
//     }
//   });

//   return Array.from(grouped.values());
// }

// // ------------------------------------------------------------------
// // EmployeeRoster
// // ------------------------------------------------------------------

// const EmployeeRoster = () => {
//   const theme = useTheme();

//   const isMobile = useMediaQuery(
//     theme.breakpoints.down("md")
//   );

//   const {
//     company_id,
//     user_id,
//     is_super,
//     is_admin,
//   } = useSelector(
//     (state) =>
//       state.GlobalVariables ||
//       state.globalVariables ||
//       {}
//   );

//   // ---------------------------------------------------------------
//   // API State
//   // ---------------------------------------------------------------

//   const [apiRows, setApiRows] =
//     useState([]);

//   const [loading, setLoading] =
//     useState(false);

//   const [error, setError] =
//     useState("");

//   // ---------------------------------------------------------------
//   // Filters
//   //
//   // searchCustomer / searchDepartment:
//   //   - Drive an INSTANT client-side filter on whatever data is
//   //     already loaded (so results narrow as you type).
//   //   - Are ALSO debounced (debouncedCustomer / debouncedDepartment)
//   //     into a real backend call, so the search is genuinely
//   //     applied server-side too, not just in the UI.
//   //
//   // dateRange:
//   //   - Just the values currently typed into the "Calendar
//   //     from/to" fields. Defaults to the CURRENT MONTH, same as
//   //     what's shown by default, so the fields aren't blank.
//   //   - Does NOT filter anything by itself.
//   //
//   // appliedDateRange:
//   //   - The date range that is actually being used to filter data
//   //     (sent to backend + drives the calendar columns).
//   //   - Defaults to the current month too, so the user sees the
//   //     current month's roster right away without having to
//   //     search for anything.
//   //   - Only changes when the user clicks "Search" (applies
//   //     whatever is in dateRange) or "Reset" (goes back to the
//   //     current month).
//   // ---------------------------------------------------------------

//   const [
//     searchCustomer,
//     setSearchCustomer,
//   ] = useState("");

//   const [
//     searchDepartment,
//     setSearchDepartment,
//   ] = useState("");

//   const [
//     debouncedCustomer,
//     setDebouncedCustomer,
//   ] = useState("");

//   const [
//     debouncedDepartment,
//     setDebouncedDepartment,
//   ] = useState("");

//   const [dateRange, setDateRange] =
//     useState(getCurrentMonthRange());

//   const [
//     appliedDateRange,
//     setAppliedDateRange,
//   ] = useState(getCurrentMonthRange());

//   // Debounce Name/Code + Department text boxes before they drive
//   // a backend re-fetch, so we don't hit the API on every keystroke.
//   useEffect(() => {
//     const handle = setTimeout(() => {
//       setDebouncedCustomer(
//         searchCustomer.trim()
//       );
//     }, SEARCH_DEBOUNCE_MS);

//     return () => clearTimeout(handle);
//   }, [searchCustomer]);

//   useEffect(() => {
//     const handle = setTimeout(() => {
//       setDebouncedDepartment(
//         searchDepartment.trim()
//       );
//     }, SEARCH_DEBOUNCE_MS);

//     return () => clearTimeout(handle);
//   }, [searchDepartment]);

//   // ---------------------------------------------------------------
//   // Pagination
//   // ---------------------------------------------------------------

//   const [page, setPage] =
//     useState(0);

//   const [
//     rowsPerPage,
//     setRowsPerPage,
//   ] = useState(10);

//   // ---------------------------------------------------------------
//   // Sorting — either Employee Name or Department column, one at a
//   // time (clicking one takes over as the active sort column).
//   // ---------------------------------------------------------------

//   const [orderBy, setOrderBy] =
//     useState("employee_name");

//   const [order, setOrder] =
//     useState("asc");

//   // ---------------------------------------------------------------
//   // Fetch Roster
//   // ---------------------------------------------------------------

//   const fetchRoster = useCallback(
//     async () => {
//       if (!company_id) {
//         setApiRows([]);
//         return;
//       }

//       setLoading(true);
//       setError("");

//       try {
//         let response;

//         // If user is admin or super, call the general endpoint
//         if (is_super || is_admin) {
//           const payload = {
//             company_id,
//           };

//           // For admin, also send search and department filters
//           if (debouncedCustomer) {
//             payload.employee_search =
//               debouncedCustomer;
//           }
//           if (debouncedDepartment) {
//             payload.department =
//               debouncedDepartment;
//           }
//           if (appliedDateRange.start) {
//             payload.startDate =
//               appliedDateRange.start;
//           }
//           if (appliedDateRange.end) {
//             payload.endDate =
//               appliedDateRange.end;
//           }
//           payload.sort_by = orderBy;
//           payload.sort_dir = order;

//           response = await configServ.getAllRosters(
//             payload
//           );
//         } else {
//           // Normal employee – fetch only their own roster
//           const payload = {};

//           // Date filters are applied both on backend and frontend
//           if (appliedDateRange.start) {
//             payload.startDate =
//               appliedDateRange.start;
//           }
//           if (appliedDateRange.end) {
//             payload.endDate =
//               appliedDateRange.end;
//           }

//           // Note: employee_search and department are NOT sent
//           // because the backend function getMyRoster does not accept them.
//           // Client-side filtering will still work instantly.
//           response = await configServ.getMyRoster(
//             payload
//           );
//         }

//         const rawRows =
//           normalizeRosterResponse(
//             response
//           );

//         const transformed =
//           transformRosterEntries(
//             rawRows
//           );

//         setApiRows(
//           transformed
//         );
//       } catch (err) {
//         const message =
//           err?.response?.data
//             ?.message ||
//           err?.message ||
//           "Failed to load roster";

//         setError(message);
//         setApiRows([]);

//         toast.error(message);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [
//       company_id,
//       user_id,
//       is_super,
//       is_admin,
//       debouncedCustomer,
//       debouncedDepartment,
//       appliedDateRange.start,
//       appliedDateRange.end,
//       orderBy,
//       order,
//     ]
//   );

//   // Initial load + automatically re-fetches whenever any of
//   // fetchRoster's dependencies change (debounced name/department,
//   // applied date range, sort).
//   useEffect(() => {
//     fetchRoster();
//   }, [fetchRoster]);

//   // ---------------------------------------------------------------
//   // Refresh after Generate / Update
//   // ---------------------------------------------------------------

//   useEffect(() => {
//     const handleRefresh =
//       () => {
//         setPage(0);
//         fetchRoster();
//       };

//     window.addEventListener(
//       "roster:refresh",
//       handleRefresh
//     );

//     return () => {
//       window.removeEventListener(
//         "roster:refresh",
//         handleRefresh
//       );
//     };
//   }, [fetchRoster]);

//   // ---------------------------------------------------------------
//   // Delete
//   // ---------------------------------------------------------------

//   const handleDelete = async (
//     rosterId
//   ) => {
//     const confirmed =
//       window.confirm(
//         "Are you sure you want to delete this roster?"
//       );

//     if (!confirmed) {
//       return;
//     }

//     try {
//       setLoading(true);

//       await configServ.deleteRoster(
//         rosterId
//       );

//       toast.success(
//         "Roster deleted successfully"
//       );

//       await fetchRoster();
//     } catch (err) {
//       const message =
//         err?.response?.data
//           ?.message ||
//         err?.message ||
//         "Failed to delete roster";

//       toast.error(message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------------------------------------------------------------
//   // Live calendar columns (only appears once dates are applied
//   // via the Search button — see appliedDateRange).
//   // ---------------------------------------------------------------

//   const dateColumns = useMemo(
//     () =>
//       buildDateColumns(
//         appliedDateRange.start,
//         appliedDateRange.end
//       ),
//     [
//       appliedDateRange.start,
//       appliedDateRange.end,
//     ]
//   );

//   // ---------------------------------------------------------------
//   // Employee rows for the calendar table.
//   //
//   // One row per employee. `cells[dateKey]` holds whatever shift
//   // info exists for that date. Rendering decides what to show for
//   // dates with no entry (WO for Sat/Sun, "—" otherwise).
//   //
//   // Both searchCustomer (Name/Code) and searchDepartment filter
//   // here too — this gives an instant result as soon as the user
//   // starts typing, on top of (and while) the debounced backend
//   // call is still in flight.
//   // ---------------------------------------------------------------

//   const employeeRows = useMemo(() => {
//     const q = searchCustomer
//       .trim()
//       .toLowerCase();

//     const qDept = searchDepartment
//       .trim()
//       .toLowerCase();

//     const map = new Map();

//     apiRows.forEach((row) => {
//       if (q) {
//         const nameMatch = String(
//           row.employee_name || ""
//         )
//           .toLowerCase()
//           .includes(q);

//         const codeMatch = String(
//           row.employee_code || ""
//         )
//           .toLowerCase()
//           .includes(q);

//         if (!nameMatch && !codeMatch) {
//           return;
//         }
//       }

//       if (qDept) {
//         const deptMatch = String(
//           row.department_name || ""
//         )
//           .toLowerCase()
//           .includes(qDept);

//         if (!deptMatch) {
//           return;
//         }
//       }

//       const empId = row.employee_id;

//       if (!map.has(empId)) {
//         map.set(empId, {
//           employee_id: empId,
//           employee_name:
//             row.employee_name,
//           employee_code:
//             row.employee_code,
//           department_name:
//             row.department_name,
//           rosterIds: [],
//           cells: {},
//         });
//       }

//       const emp = map.get(empId);

//       if (
//         !emp.rosterIds.includes(
//           row.roster_id
//         )
//       ) {
//         emp.rosterIds.push(
//           row.roster_id
//         );
//       }

//       emp.cells[row.date] = {
//         value:
//           row.shift_time ||
//           row.shift_name ||
//           row.shift_code ||
//           "Working",
//         shiftCode: row.shift_code,
//         punchIn: row.punch_in,
//         punchOut: row.punch_out,
//       };
//     });

//     const rows = Array.from(
//       map.values()
//     );

//     const sortField =
//       orderBy === "department_name"
//         ? "department_name"
//         : "employee_name";

//     rows.sort(
//       (a, b) =>
//         String(a[sortField] || "")
//           .localeCompare(
//             String(
//               b[sortField] || ""
//             )
//           ) *
//         (order === "asc" ? 1 : -1)
//     );

//     return rows;
//   }, [
//     apiRows,
//     searchCustomer,
//     searchDepartment,
//     order,
//     orderBy,
//   ]);

//   // ---------------------------------------------------------------
//   // Reset Pagination when Filters Change
//   // ---------------------------------------------------------------

//   useEffect(() => {
//     setPage(0);
//   }, [
//     searchCustomer,
//     searchDepartment,
//     appliedDateRange,
//   ]);

//   // ---------------------------------------------------------------
//   // Pagination
//   // ---------------------------------------------------------------

//   const paginatedEmployees =
//     employeeRows.slice(
//       page * rowsPerPage,
//       page * rowsPerPage +
//       rowsPerPage
//     );

//   const totalColumnCount =
//     5 + dateColumns.length + 1; // S.No, Name, ID, Code, Department + dates + Actions

//   const emptyRows =
//     page > 0
//       ? Math.max(
//         0,
//         (1 + page) *
//         rowsPerPage -
//         employeeRows.length
//       )
//       : 0;

//   // ---------------------------------------------------------------
//   // Sort
//   // ---------------------------------------------------------------

//   const handleSort = (property) => {
//     const isAsc =
//       orderBy === property &&
//       order === "asc";

//     setOrder(isAsc ? "desc" : "asc");
//     setOrderBy(property);
//   };

//   // ---------------------------------------------------------------
//   // Pagination handlers
//   // ---------------------------------------------------------------

//   const handleChangePage = (
//     event,
//     newPage
//   ) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage =
//     (event) => {
//       setRowsPerPage(
//         parseInt(
//           event.target.value,
//           10
//         )
//       );

//       setPage(0);
//     };

//   // ---------------------------------------------------------------
//   // Search — applies Name/Code + Department immediately (skips
//   // the debounce wait) AND applies whatever dates are currently
//   // typed into the Calendar from/to fields as the active date
//   // filter. This is the only thing that turns typed dates into an
//   // actual filter.
//   // ---------------------------------------------------------------

//   const handleSearch = () => {
//     setPage(0);
//     setDebouncedCustomer(
//       searchCustomer.trim()
//     );
//     setDebouncedDepartment(
//       searchDepartment.trim()
//     );
//     setAppliedDateRange({
//       start: dateRange.start,
//       end: dateRange.end,
//     });
//   };

//   // ---------------------------------------------------------------
//   // Reset — clears name/department filters and goes back to the
//   // default current-month roster (same as what loads on first
//   // visit).
//   // ---------------------------------------------------------------

//   const handleReset = () => {
//     setSearchCustomer("");
//     setSearchDepartment("");
//     setDebouncedCustomer("");
//     setDebouncedDepartment("");
//     setDateRange(getCurrentMonthRange());
//     setAppliedDateRange(
//       getCurrentMonthRange()
//     );
//     setOrderBy("employee_name");
//     setOrder("asc");
//     setPage(0);
//   };

//   // ---------------------------------------------------------------
//   // Get the roster_id to use for the delete action on a row
//   // ---------------------------------------------------------------

//   const primaryRosterId = (emp) =>
//     emp.rosterIds.length
//       ? emp.rosterIds[0]
//       : null;

//   // ---------------------------------------------------------------
//   // Calendar Cell (desktop)
//   // ---------------------------------------------------------------

//   const CalendarCell = ({
//     col,
//     entry,
//   }) => {
//     if (entry) {
//       const hasPunch =
//         entry.punchIn ||
//         entry.punchOut;

//       return (
//         <TableCell
//           align="center"
//           sx={{
//             color: "black",
//             fontWeight: 600,
//             fontSize: 12,
//             whiteSpace: "nowrap",
//             padding: "10px",
//             bgcolor: col.isWeekend
//               ? "#fff3e0"
//               : "transparent",
//           }}
//         >
//           <Typography
//             sx={{
//               fontSize: 12,
//               fontWeight: 600,
//               lineHeight: 1.2,
//             }}
//           >
//             {entry.value}
//           </Typography>

//           {hasPunch && (
//             <Typography
//               sx={{
//                 fontSize: 10,
//                 fontWeight: 500,
//                 color: "text.secondary",
//                 lineHeight: 1.2,
//               }}
//             >
//               {entry.punchIn || "—"}
//               {" / "}
//               {entry.punchOut || "—"}
//             </Typography>
//           )}
//         </TableCell>
//       );
//     }

//     if (col.isWeekend) {
//       return (
//         <TableCell
//           align="center"
//           sx={{
//             color: "#1565c0",
//             fontWeight: 700,
//             fontSize: 12,
//             padding: "10px",
//             bgcolor: "#e3f2fd",
//           }}
//         >
//           WO
//         </TableCell>
//       );
//     }

//     return (
//       <TableCell
//         align="center"
//         sx={{
//           color: "black",
//           padding: "10px",
//         }}
//       >
//         —
//       </TableCell>
//     );
//   };

//   // ---------------------------------------------------------------
//   // Mobile Card — shows the same live calendar as a horizontally
//   // scrollable strip inside each employee's card.
//   // ---------------------------------------------------------------

//   const MobileCard = ({
//     emp,
//   }) => {
//     const rosterId =
//       primaryRosterId(emp);

//     return (
//       <Card
//         sx={{
//           p: 2,
//           borderRadius: "8px",
//           boxShadow: 1,
//           borderLeft:
//             "4px solid #1976d2",
//         }}
//       >
//         <Stack spacing={1.5}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent:
//                 "space-between",
//               alignItems:
//                 "flex-start",
//             }}
//           >
//             <Box>
//               <Typography
//                 variant="subtitle1"
//                 fontWeight="bold"
//                 color="primary.main"
//               >
//                 {emp.employee_name}
//               </Typography>

//               <Typography
//                 variant="body2"
//                 color="textSecondary"
//               >
//                 {emp.employee_code ||
//                   "No code"}{" "}
//                 | ID {emp.employee_id}
//                 {emp.department_name
//                   ? ` | ${emp.department_name}`
//                   : ""}
//               </Typography>
//             </Box>

//             <Box>
//               {(is_super ||
//                 is_admin) && (
//                 <Tooltip title="Delete roster">
//                   <IconButton
//                     size="small"
//                     color="error"
//                     onClick={() =>
//                       handleDelete(
//                         rosterId
//                       )
//                     }
//                   >
//                     <DeleteIcon />
//                   </IconButton>
//                 </Tooltip>
//               )}
//             </Box>
//           </Box>

//           {dateColumns.length > 0 && (
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: 1,
//                 pt: 1,
//                 overflowX: "auto",
//                 borderTop:
//                   "1px solid #eee",
//               }}
//             >
//               {dateColumns.map(
//                 (col) => {
//                   const entry =
//                     emp.cells[
//                     col.dateKey
//                     ];

//                   const bg = entry
//                     ? col.isWeekend
//                       ? "#fff3e0"
//                       : "#f5f5f5"
//                     : col.isWeekend
//                       ? "#e3f2fd"
//                       : "#fafafa";

//                   const label = entry
//                     ? entry.value
//                     : col.isWeekend
//                       ? "WO"
//                       : "—";

//                   const punchLabel =
//                     entry &&
//                     (entry.punchIn ||
//                       entry.punchOut)
//                       ? `${entry.punchIn || "—"} / ${
//                           entry.punchOut ||
//                           "—"
//                         }`
//                       : null;

//                   return (
//                     <Box
//                       key={
//                         col.dateKey
//                       }
//                       sx={{
//                         flex:
//                           "0 0 auto",
//                         minWidth: 56,
//                         textAlign:
//                           "center",
//                         bgcolor: bg,
//                         borderRadius:
//                           "6px",
//                         p: 0.5,
//                       }}
//                     >
//                       <Typography
//                         variant="caption"
//                         display="block"
//                         color={
//                           col.isWeekend
//                             ? "#c62828"
//                             : "text.secondary"
//                         }
//                         fontWeight={
//                           600
//                         }
//                       >
//                         {col.dateNum}{" "}
//                         {col.dayShort}
//                       </Typography>

//                       <Typography
//                         variant="caption"
//                         fontWeight={
//                           600
//                         }
//                         sx={{
//                           fontSize: 10,
//                         }}
//                       >
//                         {label}
//                       </Typography>

//                       {punchLabel && (
//                         <Typography
//                           variant="caption"
//                           display="block"
//                           color="text.secondary"
//                           sx={{
//                             fontSize: 9,
//                           }}
//                         >
//                           {punchLabel}
//                         </Typography>
//                       )}
//                     </Box>
//                   );
//                 }
//               )}
//             </Box>
//           )}
//         </Stack>
//       </Card>
//     );
//   };

//   // ---------------------------------------------------------------
//   // Render
//   // ---------------------------------------------------------------

//   return (
//     <Box
//       sx={{
//         p: 2,
//         width: "100%",
//         maxWidth: "100%",        // ensure it never exceeds viewport
//         overflowX: "hidden",     // prevent horizontal page scroll
//         minHeight: "100vh",
//         bgcolor: "#ffffff",
//       }}
//     >
//       <Typography
//         variant="h5"
//         align="center"
//         fontWeight="bold"
//         color="primary"
//         sx={{ mb: 3, mt: 2 }}
//       >
//         EMPLOYEE ROSTER
//       </Typography>

//       {/* Filters */}
//       <Card
//         sx={{
//           p: 2,
//           mb: 3,
//           borderRadius: "12px",
//           borderLeft:
//             "2px solid #1976d2",
//           width: "100%",
//           boxShadow: 2,
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             alignItems: "center",
//             gap: 2,
//             width: "100%",
//           }}
//         >
//           {/* Search by Name / Code */}
//           <Box
//             sx={{
//               flex: 1,
//               minWidth: {
//                 xs: "100%",
//                 sm: "45%",
//                 md: 0,
//               },
//             }}
//           >
//             <TextField
//               fullWidth
//               label="Search by Name / Code"
//               size="small"
//               value={searchCustomer}
//               onChange={(e) =>
//                 setSearchCustomer(
//                   e.target.value
//                 )
//               }
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon fontSize="small" />
//                   </InputAdornment>
//                 ),
//               }}
//             />
//           </Box>

//           {/* Search by Department — same style/behavior as
//               the Name/Code search above, just scoped to
//               department. Instant client filter + debounced
//               backend filter. */}
//           <Box
//             sx={{
//               flex: 1,
//               minWidth: {
//                 xs: "100%",
//                 sm: "45%",
//                 md: 0,
//               },
//             }}
//           >
//             <TextField
//               fullWidth
//               label="Search by Department"
//               size="small"
//               value={searchDepartment}
//               onChange={(e) =>
//                 setSearchDepartment(
//                   e.target.value
//                 )
//               }
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon fontSize="small" />
//                   </InputAdornment>
//                 ),
//               }}
//             />
//           </Box>

//           {/* Calendar From — empty by default, not an active
//               filter until Search is clicked */}
//           <Box
//             sx={{
//               flex: 1,
//               minWidth: {
//                 xs: "100%",
//                 sm: "45%",
//                 md: 0,
//               },
//             }}
//           >
//             <TextField
//               fullWidth
//               type="date"
//               label="Calendar from"
//               size="small"
//               value={dateRange.start}
//               onChange={(e) =>
//                 setDateRange(
//                   (prev) => ({
//                     ...prev,
//                     start:
//                       e.target.value,
//                   })
//                 )
//               }
//               InputLabelProps={{
//                 shrink: true,
//               }}
//             />
//           </Box>

//           {/* Calendar To */}
//           <Box
//             sx={{
//               flex: 1,
//               minWidth: {
//                 xs: "100%",
//                 sm: "45%",
//                 md: 0,
//               },
//             }}
//           >
//             <TextField
//               fullWidth
//               type="date"
//               label="Calendar to"
//               size="small"
//               value={dateRange.end}
//               onChange={(e) =>
//                 setDateRange(
//                   (prev) => ({
//                     ...prev,
//                     end: e.target
//                       .value,
//                   })
//                 )
//               }
//               InputLabelProps={{
//                 shrink: true,
//               }}
//             />
//           </Box>

//           {/* Search + Reset */}
//           <Box
//             sx={{
//               flex: "0 0 auto",
//               width: {
//                 xs: "100%",
//                 md: "auto",
//               },
//               display: "flex",
//               gap: 1,
//               justifyContent: {
//                 xs: "flex-start",
//                 md: "flex-end",
//               },
//             }}
//           >
//             <Button
//               fullWidth={isMobile}
//               variant="contained"
//               color="primary"
//               size="small"
//               startIcon={
//                 <SearchIcon />
//               }
//               onClick={handleSearch}
//               sx={{
//                 textTransform:
//                   "uppercase",
//                 fontWeight: 700,
//                 boxShadow: "none",
//                 borderRadius: "8px",
//                 height: 40,
//               }}
//             >
//               Search
//             </Button>

//             <Button
//               fullWidth={isMobile}
//               variant="outlined"
//               color="primary"
//               size="small"
//               startIcon={
//                 <RestartAltIcon />
//               }
//               onClick={handleReset}
//               sx={{
//                 textTransform:
//                   "uppercase",
//                 fontWeight: 700,
//                 boxShadow: "none",
//                 borderRadius: "8px",
//                 height: 40,
//               }}
//             >
//               Reset
//             </Button>
//           </Box>
//         </Box>
//       </Card>

//       {/* Error */}
//       {error && (
//         <Card
//           sx={{
//             p: 2,
//             mb: 2,
//             borderLeft:
//               "4px solid #d32f2f",
//           }}
//         >
//           <Typography color="error">
//             {error}
//           </Typography>
//         </Card>
//       )}

//       {/* Loader */}
//       {loading ? (
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             my: 5,
//           }}
//         >
//           <CircularProgress />
//         </Box>
//       ) : employeeRows.length === 0 ? (
//         <Typography
//           variant="body1"
//           textAlign="center"
//           sx={{ my: 4 }}
//         >
//           No records found.
//         </Typography>
//       ) : isMobile ? (
//         /* Mobile */
//         <Box>
//           <Grid container spacing={2}>
//             {paginatedEmployees.map(
//               (emp) => (
//                 <Grid
//                   item
//                   xs={12}
//                   key={
//                     emp.employee_id
//                   }
//                 >
//                   <MobileCard
//                     emp={emp}
//                   />
//                 </Grid>
//               )
//             )}
//           </Grid>

//           <TablePagination
//             component="div"
//             count={
//               employeeRows.length
//             }
//             page={page}
//             onPageChange={
//               handleChangePage
//             }
//             rowsPerPage={
//               rowsPerPage
//             }
//             onRowsPerPageChange={
//               handleChangeRowsPerPage
//             }
//             rowsPerPageOptions={[
//               5, 10, 25,
//             ]}
//             sx={{ mt: 2 }}
//           />
//         </Box>
//       ) : (
//         /* Desktop */
//         <Paper
//           sx={{
//             width: "100%",
//             maxWidth: "100%",
//             overflow: "hidden",
//             borderRadius: "12px",
//             boxShadow: 2,
//           }}
//         >
//           <TableContainer
//             sx={{
//               maxWidth: "100%",
//               overflowX: "auto",
//             }}
//           >
//             <Table
//               size="small"
//               sx={{
//                 minWidth:
//                   520 +
//                   dateColumns.length *
//                   64,
//               }}
//             >
//               <TableHead>
//                 <TableRow
//                   sx={{
//                     backgroundColor:
//                       "primary.main",
//                   }}
//                 >
//                   <TableCell
//                     sx={{
//                       fontWeight:
//                         "bold",
//                       color: "#fff",
//                       position:
//                         "sticky",
//                       left: 0,
//                       zIndex: 3,
//                       backgroundColor:
//                         "primary.main",
//                     }}
//                   >
//                     S.No.
//                   </TableCell>

//                   <TableCell
//                     sx={{
//                       fontWeight:
//                         "bold",
//                       color: "#fff",
//                       position:
//                         "sticky",
//                       left: 60,
//                       zIndex: 3,
//                       backgroundColor:
//                         "primary.main",
//                       minWidth: 160,
//                     }}
//                     sortDirection={
//                       orderBy ===
//                         "employee_name"
//                         ? order
//                         : false
//                     }
//                   >
//                     <TableSortLabel
//                       active={
//                         orderBy ===
//                         "employee_name"
//                       }
//                       direction={
//                         orderBy ===
//                           "employee_name"
//                           ? order
//                           : "asc"
//                       }
//                       onClick={() =>
//                         handleSort(
//                           "employee_name"
//                         )
//                       }
//                       sx={{
//                         color:
//                           "#fff !important",
//                         "& .MuiTableSortLabel-icon":
//                         {
//                           color:
//                             "#fff !important",
//                           opacity:
//                             orderBy ===
//                             "employee_name"
//                               ? "1 !important"
//                               : "0.6 !important",
//                         },
//                       }}
//                     >
//                       Employee Name
//                     </TableSortLabel>
//                   </TableCell>

//                   <TableCell
//                     sx={{
//                       fontWeight:
//                         "bold",
//                       color: "#fff",
//                     }}
//                   >
//                     ID
//                   </TableCell>

//                   <TableCell
//                     sx={{
//                       fontWeight:
//                         "bold",
//                       color: "#fff",
//                     }}
//                   >
//                     Code
//                   </TableCell>

//                   <TableCell
//                     sx={{
//                       fontWeight:
//                         "bold",
//                       color: "#fff",
//                       minWidth: 120,
//                     }}
//                     sortDirection={
//                       orderBy ===
//                         "department_name"
//                         ? order
//                         : false
//                     }
//                   >
//                     <TableSortLabel
//                       active={
//                         orderBy ===
//                         "department_name"
//                       }
//                       direction={
//                         orderBy ===
//                           "department_name"
//                           ? order
//                           : "asc"
//                       }
//                       onClick={() =>
//                         handleSort(
//                           "department_name"
//                         )
//                       }
//                       sx={{
//                         color:
//                           "#fff !important",
//                         "& .MuiTableSortLabel-icon":
//                         {
//                           color:
//                             "#fff !important",
//                           opacity:
//                             orderBy ===
//                             "department_name"
//                               ? "1 !important"
//                               : "0.6 !important",
//                         },
//                       }}
//                     >
//                       Department
//                     </TableSortLabel>
//                   </TableCell>

//                   {dateColumns.map(
//                     (col) => (
//                       <TableCell
//                         key={
//                           col.dateKey
//                         }
//                         align="center"
//                         sx={{
//                           fontWeight:
//                             "bold",
//                           color: "#fff",
//                           minWidth: 64,
//                           bgcolor:
//                             col.isWeekend
//                               ? "#c62828"
//                               : "primary.main",
//                         }}
//                       >
//                         <Typography
//                           variant="caption"
//                           display="block"
//                           sx={{
//                             fontWeight:
//                               "bold",
//                             lineHeight:
//                               1.1,
//                           }}
//                         >
//                           {col.dateNum}
//                         </Typography>
//                         <Typography
//                           variant="caption"
//                           sx={{
//                             fontSize: 10,
//                           }}
//                         >
//                           {
//                             col.dayShort
//                           }
//                         </Typography>
//                       </TableCell>
//                     )
//                   )}

//                   <TableCell
//                     sx={{
//                       fontWeight:
//                         "bold",
//                       color: "#fff",
//                     }}
//                     align="center"
//                   >
//                     Actions
//                   </TableCell>
//                 </TableRow>
//               </TableHead>

//               <TableBody>
//                 {paginatedEmployees.map(
//                   (emp, index) => {
//                     const rosterId =
//                       primaryRosterId(
//                         emp
//                       );

//                     return (
//                       <TableRow
//                         key={
//                           emp.employee_id
//                         }
//                         hover
//                       >
//                         <TableCell
//                           sx={{
//                             position:
//                               "sticky",
//                             left: 0,
//                             zIndex: 1,
//                             backgroundColor:
//                               "#fff",
//                           }}
//                         >
//                           {page *
//                             rowsPerPage +
//                             index +
//                             1}
//                         </TableCell>

//                         <TableCell
//                           sx={{
//                             fontWeight: 500,
//                             position:
//                               "sticky",
//                             left: 60,
//                             zIndex: 1,
//                             backgroundColor:
//                               "#fff",
//                           }}
//                         >
//                           {
//                             emp.employee_name
//                           }
//                         </TableCell>

//                         <TableCell
//                           sx={{
//                             fontFamily:
//                               "monospace",
//                           }}
//                         >
//                           {
//                             emp.employee_id
//                           }
//                         </TableCell>

//                         <TableCell
//                           sx={{
//                             fontFamily:
//                               "monospace",
//                           }}
//                         >
//                           {
//                             emp.employee_code
//                           }
//                         </TableCell>

//                         <TableCell>
//                           {emp.department_name || "—"}
//                         </TableCell>

//                         {dateColumns.map(
//                           (col) => (
//                             <CalendarCell
//                               key={
//                                 col.dateKey
//                               }
//                               col={col}
//                               entry={
//                                 emp
//                                   .cells[
//                                   col
//                                     .dateKey
//                                 ]
//                               }
//                             />
//                           )
//                         )}

//                         <TableCell
//                           align="center"
//                         >
//                           {(is_super ||
//                             is_admin) && (
//                             <Tooltip title="Delete roster">
//                               <IconButton
//                                 size="small"
//                                 color="error"
//                                 onClick={() =>
//                                   handleDelete(
//                                     rosterId
//                                   )
//                                 }
//                               >
//                                 <DeleteIcon fontSize="small" />
//                               </IconButton>
//                             </Tooltip>
//                           )}
//                         </TableCell>
//                       </TableRow>
//                     );
//                   }
//                 )}

//                 {emptyRows > 0 && (
//                   <TableRow
//                     style={{
//                       height:
//                         53 * emptyRows,
//                     }}
//                   >
//                     <TableCell
//                       colSpan={
//                         totalColumnCount
//                       }
//                     />
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>

//           <TablePagination
//             rowsPerPageOptions={[
//               5, 10, 25,
//             ]}
//             component="div"
//             count={
//               employeeRows.length
//             }
//             rowsPerPage={
//               rowsPerPage
//             }
//             page={page}
//             onPageChange={
//               handleChangePage
//             }
//             onRowsPerPageChange={
//               handleChangeRowsPerPage
//             }
//           />
//         </Paper>
//       )}
//     </Box>
//   );
// };

// export default EmployeeRoster;

import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
} from "react";

import {
  Card,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  TablePagination,
  Typography,
  Box,
  CircularProgress,
  useTheme,
  useMediaQuery,
  Button,
  Grid,
  Stack,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

import toast from "react-hot-toast";
import configServ from "../services/config";
import { useSelector } from "react-redux";

// ------------------------------------------------------------------
// Constants
// ------------------------------------------------------------------

// Sun(0) ... Sat(6) — matches Date.getDay()
const DOW_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// ------------------------------------------------------------------
// Date Helpers
// ------------------------------------------------------------------

function pad(n) {
  return String(n).padStart(2, "0");
}

function parseApiDate(value) {
  if (!value) return null;
  const str = String(value);
  if (str.includes("T")) return new Date(str);
  return new Date(`${str.substring(0, 10)}T00:00:00`);
}

function toInputDate(value) {
  if (!value) return "";
  if (value instanceof Date) {
    return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(
      value.getDate()
    )}`;
  }
  return String(value).substring(0, 10);
}

function getDateKey(value) {
  const date = value instanceof Date ? value : parseApiDate(value);
  if (!date || Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}`;
}

function addDays(date, delta) {
  const d = new Date(date);
  d.setDate(d.getDate() + delta);
  return d;
}

function getCurrentMonthRange() {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), 1);
  const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return { start: toInputDate(start), end: toInputDate(end) };
}

// Builds the "live calendar" columns for the table: one column per
// actual date between start and end (inclusive), flagged as weekend
// (Sat/Sun) or not.
//
// If either date is missing (no date filter applied yet), no date
// columns are shown at all — this keeps the calendar "unselected"
// by default.
function buildDateColumns(startStr, endStr) {
  if (!startStr || !endStr) return [];

  const start = parseApiDate(startStr);
  const end = parseApiDate(endStr);

  if (
    !start ||
    !end ||
    Number.isNaN(start.getTime()) ||
    Number.isNaN(end.getTime()) ||
    start > end
  ) {
    return [];
  }

  const columns = [];
  let cursor = new Date(start);
  let guard = 0; // safety cap so a bad range can't freeze the UI

  while (cursor <= end && guard < 370) {
    const dow = cursor.getDay();

    columns.push({
      dateKey: getDateKey(cursor),
      dateNum: cursor.getDate(),
      dayShort: DOW_SHORT[dow],
      isWeekend: dow === 0 || dow === 6,
    });

    cursor = addDays(cursor, 1);
    guard += 1;
  }

  return columns;
}

// ------------------------------------------------------------------
// API Row -> Display Row
// ------------------------------------------------------------------

function normalizeRosterResponse(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  return [];
}

// ------------------------------------------------------------------
// Group API Entries
//
// Backend returns one entry per: roster + customer + date.
// We collapse that down to one entry per: roster + employee + date
// (dedup customers into customerIds).
//
// The calendar table itself is built separately (see useMemo
// `employeeRows` below), grouping these flat rows by employee so
// each employee gets ONE row with all their dates as columns.
// ------------------------------------------------------------------

function transformRosterEntries(apiRows) {
  const grouped = new Map();

  apiRows.forEach((item) => {
    const rosterId = Number(item.roster_id || item.id || item.rosterId);
    const employeeId = Number(item.employee_id);
    const date = item.roster_date || item.date;

    if (!rosterId || !employeeId || !date) return;

    const dateKey = getDateKey(date);
    const key = `${rosterId}_${employeeId}_${dateKey}`;

    if (!grouped.has(key)) {
      grouped.set(key, {
        roster_id: rosterId,
        employee_id: employeeId,
        employee_name:
          item.employee_name || item.name || `Employee #${employeeId}`,
        employee_code: item.employee_code || item.emp_code || "",
        department_id: Number(item.department_id || item.dept_id || 0),
        department_name:
          item.department_name || item.dept_name || item.department || "",
        date: dateKey,
        shift_id: Number(item.shift_id || 0),
        shift_name: item.shift_name || "",
        shift_code: item.shift_code || "",
        shift_time: item.shift_time || item.formatted_shift_time || "",
        // That day's actual attendance punch (from the backend's
        // attendances left-join) — null when not punched yet.
        punch_in: item.punch_in || null,
        punch_out: item.punch_out || null,
        status: item.status ?? 1,
        customerIds: [],
      });
    }

    const row = grouped.get(key);
    const customerId = Number(item.customer_id);

    if (customerId && !row.customerIds.includes(customerId)) {
      row.customerIds.push(customerId);
    }
  });

  return Array.from(grouped.values());
}

// ------------------------------------------------------------------
// EmployeeRoster
// ------------------------------------------------------------------

const EmployeeRoster = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { company_id, user_id, is_super, is_admin } = useSelector(
    (state) => state.GlobalVariables || state.globalVariables || {}
  );

  // ---------------------------------------------------------------
  // API State
  // ---------------------------------------------------------------

  const [apiRows, setApiRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ---------------------------------------------------------------
  // Filters
  //
  // dateRange:
  //   - Just the values currently typed into the "Calendar from/to"
  //     fields. Defaults to the CURRENT MONTH so the fields aren't
  //     blank. Does NOT filter anything by itself.
  //
  // appliedDateRange:
  //   - The date range actually used to filter data (sent to
  //     backend + drives the calendar columns). Defaults to the
  //     current month too. Only changes on "Search" (applies
  //     dateRange) or "Reset" (back to current month).
  // ---------------------------------------------------------------

  const [dateRange, setDateRange] = useState(getCurrentMonthRange());
  const [appliedDateRange, setAppliedDateRange] = useState(
    getCurrentMonthRange()
  );

  // ---------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // ---------------------------------------------------------------
  // Sorting — either Employee Name or Department column, one at a
  // time (clicking one takes over as the active sort column).
  // ---------------------------------------------------------------

  const [orderBy, setOrderBy] = useState("employee_name");
  const [order, setOrder] = useState("asc");

  // ---------------------------------------------------------------
  // Fetch Roster
  // ---------------------------------------------------------------

  const fetchRoster = useCallback(async () => {
    if (!company_id) {
      setApiRows([]);
      return;
    }

    setLoading(true);
    setError("");

    try {
      let response;

      if (is_super || is_admin) {
        // Admin/super — general endpoint
        const payload = { company_id };

        if (appliedDateRange.start) payload.startDate = appliedDateRange.start;
        if (appliedDateRange.end) payload.endDate = appliedDateRange.end;
        payload.sort_by = orderBy;
        payload.sort_dir = order;

        response = await configServ.getAllRosters(payload);
      } else {
        // Normal employee – fetch only their own roster.
        const payload = {};

        if (appliedDateRange.start) payload.startDate = appliedDateRange.start;
        if (appliedDateRange.end) payload.endDate = appliedDateRange.end;

        response = await configServ.getMyRoster(payload);
      }

      const rawRows = normalizeRosterResponse(response);
      setApiRows(transformRosterEntries(rawRows));
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || "Failed to load roster";

      setError(message);
      setApiRows([]);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  }, [
    company_id,
    user_id,
    is_super,
    is_admin,
    appliedDateRange.start,
    appliedDateRange.end,
    orderBy,
    order,
  ]);

  // Initial load + automatically re-fetches whenever any of
  // fetchRoster's dependencies change.
  useEffect(() => {
    fetchRoster();
  }, [fetchRoster]);

  // ---------------------------------------------------------------
  // Refresh after Generate / Update
  // ---------------------------------------------------------------

  useEffect(() => {
    const handleRefresh = () => {
      setPage(0);
      fetchRoster();
    };

    window.addEventListener("roster:refresh", handleRefresh);
    return () => window.removeEventListener("roster:refresh", handleRefresh);
  }, [fetchRoster]);

  // ---------------------------------------------------------------
  // Live calendar columns (only appears once dates are applied via
  // the Search button — see appliedDateRange).
  // ---------------------------------------------------------------

  const dateColumns = useMemo(
    () => buildDateColumns(appliedDateRange.start, appliedDateRange.end),
    [appliedDateRange.start, appliedDateRange.end]
  );

  // ---------------------------------------------------------------
  // Employee rows for the calendar table.
  //
  // One row per employee. `cells[dateKey]` holds whatever shift info
  // exists for that date. Rendering decides what to show for dates
  // with no entry (WO for Sat/Sun, "—" otherwise).
  // ---------------------------------------------------------------

  const employeeRows = useMemo(() => {
    const map = new Map();

    apiRows.forEach((row) => {
      const empId = row.employee_id;

      if (!map.has(empId)) {
        map.set(empId, {
          employee_id: empId,
          employee_name: row.employee_name,
          employee_code: row.employee_code,
          department_name: row.department_name,
          cells: {},
        });
      }

      map.get(empId).cells[row.date] = {
        value:
          row.shift_time || row.shift_name || row.shift_code || "Working",
        shiftCode: row.shift_code,
        punchIn: row.punch_in,
        punchOut: row.punch_out,
      };
    });

    const rows = Array.from(map.values());

    const sortField =
      orderBy === "department_name" ? "department_name" : "employee_name";

    rows.sort(
      (a, b) =>
        String(a[sortField] || "").localeCompare(String(b[sortField] || "")) *
        (order === "asc" ? 1 : -1)
    );

    return rows;
  }, [apiRows, order, orderBy]);

  // ---------------------------------------------------------------
  // Reset Pagination when Filters Change
  // ---------------------------------------------------------------

  useEffect(() => {
    setPage(0);
  }, [appliedDateRange]);

  // ---------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------

  const paginatedEmployees = employeeRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // Columns: Employee Name, Department + dates
  const totalColumnCount = 2 + dateColumns.length;

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - employeeRows.length)
      : 0;

  // ---------------------------------------------------------------
  // Sort
  // ---------------------------------------------------------------

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // ---------------------------------------------------------------
  // Pagination handlers
  // ---------------------------------------------------------------

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // ---------------------------------------------------------------
  // Search — applies whatever dates are currently typed into the
  // Calendar from/to fields as the active date filter.
  // ---------------------------------------------------------------

  const handleSearch = () => {
    setPage(0);
    setAppliedDateRange({ start: dateRange.start, end: dateRange.end });
  };

  // ---------------------------------------------------------------
  // Reset — goes back to the default current-month roster (same
  // as first visit).
  // ---------------------------------------------------------------

  const handleReset = () => {
    setDateRange(getCurrentMonthRange());
    setAppliedDateRange(getCurrentMonthRange());
    setOrderBy("employee_name");
    setOrder("asc");
    setPage(0);
  };

  // ---------------------------------------------------------------
  // Calendar Cell (desktop)
  // ---------------------------------------------------------------

  const CalendarCell = ({ col, entry }) => {
    if (entry) {
      const hasPunch = entry.punchIn || entry.punchOut;

      return (
        <TableCell
          align="center"
          sx={{
            color: "black",
            fontWeight: 600,
            fontSize: 12,
            whiteSpace: "nowrap",
            padding: "10px",
            bgcolor: col.isWeekend ? "#fff3e0" : "transparent",
          }}
        >
          <Typography sx={{ fontSize: 12, fontWeight: 600, lineHeight: 1.2 }}>
            {entry.value}
          </Typography>

          {hasPunch && (
            <Typography
              sx={{
                fontSize: 10,
                fontWeight: 500,
                color: "text.secondary",
                lineHeight: 1.2,
              }}
            >
              {entry.punchIn || "—"} / {entry.punchOut || "—"}
            </Typography>
          )}
        </TableCell>
      );
    }

    if (col.isWeekend) {
      return (
        <TableCell
          align="center"
          sx={{
            color: "#1565c0",
            fontWeight: 700,
            fontSize: 12,
            padding: "10px",
            bgcolor: "#e3f2fd",
          }}
        >
          WO
        </TableCell>
      );
    }

    return (
      <TableCell align="center" sx={{ color: "black", padding: "10px" }}>
        —
      </TableCell>
    );
  };

  // ---------------------------------------------------------------
  // Mobile Card — shows the same live calendar as a horizontally
  // scrollable strip inside each employee's card.
  // ---------------------------------------------------------------

  const MobileCard = ({ emp }) => (
    <Card
      sx={{
        p: 2,
        borderRadius: "8px",
        boxShadow: 1,
        borderLeft: "4px solid #1976d2",
      }}
    >
      <Stack spacing={1.5}>
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color="primary.main">
            {emp.employee_name}
          </Typography>

          <Typography variant="body2" color="textSecondary">
            {emp.department_name || "—"}
          </Typography>
        </Box>

        {dateColumns.length > 0 && (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              pt: 1,
              overflowX: "auto",
              borderTop: "1px solid #eee",
            }}
          >
            {dateColumns.map((col) => {
              const entry = emp.cells[col.dateKey];

              const bg = entry
                ? col.isWeekend
                  ? "#fff3e0"
                  : "#f5f5f5"
                : col.isWeekend
                ? "#e3f2fd"
                : "#fafafa";

              const label = entry
                ? entry.value
                : col.isWeekend
                ? "WO"
                : "—";

              const punchLabel =
                entry && (entry.punchIn || entry.punchOut)
                  ? `${entry.punchIn || "—"} / ${entry.punchOut || "—"}`
                  : null;

              return (
                <Box
                  key={col.dateKey}
                  sx={{
                    flex: "0 0 auto",
                    minWidth: 56,
                    textAlign: "center",
                    bgcolor: bg,
                    borderRadius: "6px",
                    p: 0.5,
                  }}
                >
                  <Typography
                    variant="caption"
                    display="block"
                    color={col.isWeekend ? "#c62828" : "text.secondary"}
                    fontWeight={600}
                  >
                    {col.dateNum} {col.dayShort}
                  </Typography>

                  <Typography
                    variant="caption"
                    fontWeight={600}
                    sx={{ fontSize: 10 }}
                  >
                    {label}
                  </Typography>

                  {punchLabel && (
                    <Typography
                      variant="caption"
                      display="block"
                      color="text.secondary"
                      sx={{ fontSize: 9 }}
                    >
                      {punchLabel}
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>
        )}
      </Stack>
    </Card>
  );

  // ---------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------

  return (
    <Box
      sx={{
        p: 2,
        width: "100%",
        maxWidth: "100%", // ensure it never exceeds viewport
        overflowX: "hidden", // prevent horizontal page scroll
        minHeight: "100vh",
        bgcolor: "#ffffff",
      }}
    >
      <Typography
        variant="h5"
        align="center"
        fontWeight="bold"
        color="primary"
        sx={{ mb: 3, mt: 2 }}
      >
        EMPLOYEE ROSTER
      </Typography>

      {/* Filters — only the calendar date range + Search/Reset */}
      <Card
        sx={{
          p: 2,
          mb: 3,
          borderRadius: "12px",
          borderLeft: "2px solid #1976d2",
          width: "100%",
          boxShadow: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 2,
            width: "100%",
          }}
        >
          {/* Calendar From — empty by default, not an active filter
              until Search is clicked */}
          <Box sx={{ flex: 1, minWidth: { xs: "100%", sm: "45%", md: 0 } }}>
            <TextField
              fullWidth
              type="date"
              label="Calendar from"
              size="small"
              value={dateRange.start}
              onChange={(e) =>
                setDateRange((prev) => ({ ...prev, start: e.target.value }))
              }
              InputLabelProps={{ shrink: true }}
            />
          </Box>

          {/* Calendar To */}
          <Box sx={{ flex: 1, minWidth: { xs: "100%", sm: "45%", md: 0 } }}>
            <TextField
              fullWidth
              type="date"
              label="Calendar to"
              size="small"
              value={dateRange.end}
              onChange={(e) =>
                setDateRange((prev) => ({ ...prev, end: e.target.value }))
              }
              InputLabelProps={{ shrink: true }}
            />
          </Box>

          {/* Search + Reset */}
          <Box
            sx={{
              flex: "0 0 auto",
              width: { xs: "100%", md: "auto" },
              display: "flex",
              gap: 1,
              justifyContent: { xs: "flex-start", md: "flex-end" },
            }}
          >
            <Button
              fullWidth={isMobile}
              variant="contained"
              color="primary"
              size="small"
              startIcon={<SearchIcon />}
              onClick={handleSearch}
              sx={{
                textTransform: "uppercase",
                fontWeight: 700,
                boxShadow: "none",
                borderRadius: "8px",
                height: 40,
              }}
            >
              Search
            </Button>

            <Button
              fullWidth={isMobile}
              variant="outlined"
              color="primary"
              size="small"
              startIcon={<RestartAltIcon />}
              onClick={handleReset}
              sx={{
                textTransform: "uppercase",
                fontWeight: 700,
                boxShadow: "none",
                borderRadius: "8px",
                height: 40,
              }}
            >
              Reset
            </Button>
          </Box>
        </Box>
      </Card>

      {/* Error */}
      {error && (
        <Card sx={{ p: 2, mb: 2, borderLeft: "4px solid #d32f2f" }}>
          <Typography color="error">{error}</Typography>
        </Card>
      )}

      {/* Loader */}
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 5 }}>
          <CircularProgress />
        </Box>
      ) : employeeRows.length === 0 ? (
        <Typography variant="body1" textAlign="center" sx={{ my: 4 }}>
          No records found.
        </Typography>
      ) : isMobile ? (
        /* Mobile */
        <Box>
          <Grid container spacing={2}>
            {paginatedEmployees.map((emp) => (
              <Grid item xs={12} key={emp.employee_id}>
                <MobileCard emp={emp} />
              </Grid>
            ))}
          </Grid>

          <TablePagination
            component="div"
            count={employeeRows.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            sx={{ mt: 2 }}
          />
        </Box>
      ) : (
        /* Desktop */
        <Paper
          sx={{
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            borderRadius: "12px",
            boxShadow: 2,
          }}
        >
          <TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
            <Table
              size="small"
              sx={{ minWidth: 300 + dateColumns.length * 64 }}
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "primary.main" }}>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#fff",
                      position: "sticky",
                      left: 0,
                      zIndex: 3,
                      backgroundColor: "primary.main",
                      minWidth: 160,
                    }}
                    sortDirection={orderBy === "employee_name" ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === "employee_name"}
                      direction={orderBy === "employee_name" ? order : "asc"}
                      onClick={() => handleSort("employee_name")}
                      sx={{
                        color: "#fff !important",
                        "& .MuiTableSortLabel-icon": {
                          color: "#fff !important",
                          opacity:
                            orderBy === "employee_name"
                              ? "1 !important"
                              : "0.6 !important",
                        },
                      }}
                    >
                      Employee Name
                    </TableSortLabel>
                  </TableCell>

                  <TableCell
                    sx={{ fontWeight: "bold", color: "#fff", minWidth: 120 }}
                    sortDirection={
                      orderBy === "department_name" ? order : false
                    }
                  >
                    <TableSortLabel
                      active={orderBy === "department_name"}
                      direction={
                        orderBy === "department_name" ? order : "asc"
                      }
                      onClick={() => handleSort("department_name")}
                      sx={{
                        color: "#fff !important",
                        "& .MuiTableSortLabel-icon": {
                          color: "#fff !important",
                          opacity:
                            orderBy === "department_name"
                              ? "1 !important"
                              : "0.6 !important",
                        },
                      }}
                    >
                      Department
                    </TableSortLabel>
                  </TableCell>

                  {dateColumns.map((col) => (
                    <TableCell
                      key={col.dateKey}
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        color: "#fff",
                        minWidth: 64,
                        bgcolor: col.isWeekend ? "#c62828" : "primary.main",
                      }}
                    >
                      <Typography
                        variant="caption"
                        display="block"
                        sx={{ fontWeight: "bold", lineHeight: 1.1 }}
                      >
                        {col.dateNum}
                      </Typography>
                      <Typography variant="caption" sx={{ fontSize: 10 }}>
                        {col.dayShort}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {paginatedEmployees.map((emp) => (
                  <TableRow key={emp.employee_id} hover>
                    <TableCell
                      sx={{
                        fontWeight: 500,
                        position: "sticky",
                        left: 0,
                        zIndex: 1,
                        backgroundColor: "#fff",
                      }}
                    >
                      {emp.employee_name}
                    </TableCell>

                    <TableCell>{emp.department_name || "—"}</TableCell>

                    {dateColumns.map((col) => (
                      <CalendarCell
                        key={col.dateKey}
                        col={col}
                        entry={emp.cells[col.dateKey]}
                      />
                    ))}
                  </TableRow>
                ))}

                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={totalColumnCount} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={employeeRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}
    </Box>
  );
};

export default EmployeeRoster;